"use client";

import { Provider as JotaiProvider } from "jotai";
import { SessionProvider } from "next-auth/react";
import { I18nProviderClient } from "~/locales/client";
import { LocaleEnum } from "~/locales/resources";
import CookieHandler from "./CookieHandler";
import Tracking from "./Tracking";
import HotjarWrapper from "~/components/hotjar/HotjarWrapper";
import PostHogProvider from "~/components/posthog/PostHogProvider";

type ProviderProps = {
  children: React.ReactNode;
  locale: LocaleEnum;
};

/**
 * Providers for the app
 * - Has to be client component, because all the providers/handlers are client components
 * @param children - The children to render
 * @param locale - The locale to use
 */
const Providers = ({ children, locale }: ProviderProps) => {
  return (
    <SessionProvider>
      <I18nProviderClient locale={locale}>
        <JotaiProvider>
          <CookieHandler />
          {children}
          <Tracking locale={locale as LocaleEnum} />
          <HotjarWrapper />
          <PostHogProvider />
        </JotaiProvider>
      </I18nProviderClient>
    </SessionProvider>
  );
};

export default Providers;
